import { render, staticRenderFns } from "./StudyResultResolve.vue?vue&type=template&id=6654488e&lang=pug"
import script from "./StudyResultResolve.vue?vue&type=script&lang=ts"
export * from "./StudyResultResolve.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports